<template lang="pug">
  shListData(title="Codes History" resolver="codesHistory" keyData="_id" component="shCode" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'CodesHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/code/CodesHistory.vue